__turbopack_context__.v({
  "hyperlink": "etlXAW_hyperlink",
});
